import { authHeader } from '../_helpers';
import axios from 'axios';

export const motivationService = {
  saveMotivation,
  updateMotivation,
  getMotivation
  /*   saveProfile,
  getProfile */
};

async function saveMotivation(motivation) {
  return axios.post(process.env.ROOT_API + '/api/v1/motivations', motivation, {
    headers: authHeader()
  });
}

async function getMotivation(id) {
  return axios.get(process.env.ROOT_API + '/api/v1/motivations/' + id, {
    headers: authHeader()
  });
}

async function updateMotivation(id, motivation) {
  return axios.put(
    process.env.ROOT_API + '/api/v1/motivations/' + id,
    motivation,
    { headers: authHeader() }
  );
}



// WEBPACK FOOTER //
// ./src/_services/motivation.js